import type { TranslationKeys } from "./en";
import { TKey } from "./translationKeys";

export const sv: Record<TranslationKeys, string> = {
  replace_photo: "Byt bild",
  upload_photo: "Ladda upp bild",

  go_to_plan: "Gå till plan",
  home: "Hemmaskärm",
  profile: "Profil",

  home_intro_1: "Det ENDA verktyget du behöver för din nästa planering.",
  home_intro_2: "Ingen inloggning och extremt gratis.",

  home_your_planiras: "Dina Planiras",
  home_start_planira_1: "Starta Planira",
  home_start_planira_2: "Hitta en bra mall nedan för att börja titt äventyr.",
  home_no_planiras: "Inget här än,",
  home_no_planiras_message: "Skapa din första Planira nedan.",
  home_sign_in_hint:
    "If you have registered your email you can try sign in below!",
  home_create_new: "SKAPA NY PLANIRA",

  sign_in_box_confirm_title: "Är du säker?",
  sign_in_box_confirm_description:
    "Du kommer att loggas ut och behöver ditt lösenord för att logga in igen.",
  sign_in_box_sign_out: "Logga ut",
  sign_in_box_returning_user: "Återvändande användare?",
  sign_in_box_returning_user_message:
    "Maximera potentialen i Planira genom att logga in för att enkelt hålla koll på alla dina Planiras. Planira fungerar utmärkt utan registrering, men att logga in säkerställer smidig åtkomst till dina Planiras.",
  sign_in_box_sign_in: "Logga in",

  plan_add_step_cta_question: "Vill du gå vidare till nästa steg?",
  plan_add_step_cta_description:
    "Slutför denna åtgärd för att gå vidare i din plan.",
  plan_add_step_cta_deny: "Nej",
  plan_add_step_cta_accept: "Ja! Kör på",
  plan_add_step_outro_title: "Du är klar!",
  plan_add_step_outro_description:
    "Fantastiskt arbete! Du är klar för denna gång.",
  plan_add_step_general_question: "Lägg till ett nytt steg?",
  plan_add_step_general_description:
    "Lägg till ett nytt steg om du har fler saker att planera just nu.",
  plan_add_step_general_accept: "Ja! Kör på",

  plan_hotels_tips_waiting_title: "Väntar på att få hjälpa till...",
  plan_hotels_tips_waiting_description:
    "När vi har tillräckligt med information kommer vi att visa tips här om var du kan bo under ditt äventyr.",

  create_screen_planira_full_title: "Full Planira",
  create_screen_planira_full_description:
    "Dyk in i detaljerad planering för ditt nästa äventyr.",
  create_screen_planira_full_tips:
    "Full Planira är designad för omfattande planeringsbehov. Börja med en full setup för att hantera flera aspekter av ditt evenemang eller projekt, idealisk för detaljerad och komplex planering.",
  create_screen_planira_quickstart_title: "Börja planera",
  create_screen_planira_quickstart_description:
    "Välj en startpunkt för att planera din perfekta upplevelse. Börja enkelt och dyk in i detaljerna senare!",
  create_screen_more_experiences: "Fler upplevelser",
  create_screen_more_experiences_description:
    "Vi har {{count}}+ fler äventyr förberedda för dig här",

  [TKey.ActivityStateSetToDone]: "Blev markerad som klar!",
  [TKey.ActivityStateSetToPlanning]: "Återställdes till planering",
  [TKey.ActivityEmojiChanged]: "Ändrade ikon %oldValue% -> %newValue%",
  [TKey.ActivityDescriptionChanged]: "Uppdaterade beskrivningen",
  [TKey.ActivityTitleChange]:
    "Uppdaterade titeln från %oldValue% till %newValue%",
  [TKey.ActivityRestoredCard]: "Återställde detta från arkivet",
  [TKey.ActivityArchivedCard]: "Flyttade detta till arkivet",
  [TKey.ActivityMovedCard]: "Flyttade till grupp %newValue% från %oldValue%",
  [TKey.ActivityUpdatedTextInPoll]:
    "Uppdaterade texten från %oldValue% till %newValue%",
  [TKey.ActivityPlanInfoDescriptionUpdated]:
    "Uppdaterade beskrivningen från %oldValue% till %newValue%",
  [TKey.ActivityPlanInfoImageUpdated]: "Uppdaterade bilden",
  [TKey.ActivityUpdatedDescriptionInLocation]:
    "Uppdaterade beskrivningen från %oldValue% till %newValue% vid plats %location%",
  [TKey.ActivityUpdatedPositionInLocation]:
    "Uppdaterade positionen för plats %location%",
  [TKey.ActivityUpdatedLocation]: "Uppdaterade platsen %location%",
  [TKey.ActivityInfoTextUpdated]:
    "Uppdaterade beskrivningen från %oldValue% till %newValue%",
  [TKey.ActivityPollOptionUpdated]:
    "Uppdaterade alternativ från %oldValue% till %newValue%",
  [TKey.ActivityRsvpUpdated]: 'Uppdaterade RSVP-status till "%newValue%"',
  [TKey.ActivityCheckboxAssignedTo]: "Tilldelade %label% till %displayName%",
  [TKey.ActivityCheckboxAssignedRemoved]:
    "Tog bort %displayName% som tilldelad till %label%",
  [TKey.ActivityCheckboxLabelUpdated]:
    "Uppdaterade alternativet %oldValue% till %newValue%",
  [TKey.ActivityCheckboxCompleted]: "Slutförde %label%",
  [TKey.ActivityCheckboxReset]: "Återställde %label%",
  [TKey.ActivityCalendarDatesSet]: "Angav tillgängliga datum till %dates%",
  [TKey.ActivityDateDueAssignedTo]: "Tilldelade %label% till %displayName%",
  [TKey.ActivityDateDueAssignedRemoved]:
    "Tog bort %displayName% som tilldelad till %label%",
  [TKey.ActivityDateDueDescriptionUpdated]:
    "Uppdaterade beskrivningen från %oldValue% till %newValue%",
  [TKey.ActivityDateDueCompleted]: "Markerades som slutförd!",
  [TKey.ActivityDateDueReset]: "Återöppnades",
  [TKey.ActivityExpensesSettlementAdded]:
    "Lade till avräkning från %debtorName% → %creditorName% (%amount%)",
  [TKey.ActivityExpensesExpenseAdded]: "Betalade %amount% %title%",
  [TKey.ActivityExpensesExpenseUpdated]:
    "Uppdaterade utgift %title% %oldAmount% -> %amount%",
  [TKey.ActivityCheckboxAdded]: "Lade till alternativ %label%",
  [TKey.ActivityRatingSet]: "Betygsatte alternativet %label% som %rating%",
  [TKey.ActivityCommentAdded]: "%comment%",
  [TKey.ActivityPollOptionAdded]: "Lade till %label% som alternativ",
  [TKey.ActivityLocationAdded]: "Lade till plats %label% som alternativ",
  [TKey.ActivityModuleAdded]: "Lade till steg %label%",
  [TKey.ActivityModuleCopied]: "Kopierade steg %label%",
  [TKey.ActivityPollVotedFor]: "Röstade på alternativ %label%",
  [TKey.ActivityPollStoppedVotingFor]: "Slutade rösta på alternativ %label%",
  [TKey.ActivityDataWithLabelDeleted]: "Raderade %label%",
  [TKey.ActivityTrackerItemAdded]: "La till %type% x %amount% %comment%",
  [TKey.ActivityReminderAssignedTo]: "Tilldelade %label% till %displayName%",
  [TKey.ActivityReminderAssignedRemoved]:
    "Tog bort %displayName% som tilldelad till %label%",
  [TKey.ActivityReminderDescriptionUpdated]:
    "Uppdaterade beskrivningen från %oldValue% till %newValue%",
  [TKey.ActivityReminderCompleted]: "Markerades som slutförd!",
  [TKey.ActivityReminderReset]: "Återöppnades",
  [TKey.BusinessFeedItemPosted]: "%comment%",
  [TKey.BusinessFeedCommentPosted]: "%comment%",
  [TKey.BusinessFeedCommentReplyPosted]: "%comment%",
};
